export const utcFromTime = (time, date) => {
    const [hours, minutes] = time.split(":").map(Number);
    const utcDate = new Date(date || Date.now());
    utcDate.setUTCHours(hours, minutes, 0, 0);
    return utcDate.toISOString();
};
//# sourceMappingURL=utcFromTime.js.map
